import React from 'react'
import { Icons } from '../constants'
import { UserInfo, LanguageContext } from '../contexts'
import { URLS } from '../http'

export function Login() {
	const { localizedText } = React.useContext(LanguageContext)

	if (!UserInfo.isUserLoggedIn()) return (
		<div className="login dropdown">
			<div className="dropdown-trigger">
				<button className="button is-small" aria-haspopup="true" aria-controls="dropdown-menu" onClick={() => window.location.href = URLS.IDENTITY_SERVER_DASHBOARD}>
					<span>{localizedText.Login}</span>
				</button>
			</div>
		</div>
	)

	else {

		const adminLinkItem = UserInfo.canUserAdmin() ?
			<a href='/' className="dropdown-item">
				{localizedText.Admin}
			</a> :
			null

		return (
			<div className="login dropdown is-hoverable">
				<div className="dropdown-trigger">
					<button className="button is-small" aria-haspopup="true" aria-controls="dropdown-menu">
						<span>{UserInfo.getUserName()}</span>
						<span className="icon is-small">
							<i aria-hidden="true">{Icons.chevronDown}</i>
						</span>
					</button>
				</div>
				<div className="dropdown-menu" id="dropdown-menu" role="menu">
					<div className="dropdown-content">
						{adminLinkItem}
						<a href={URLS.IDENTITY_SERVER_DASHBOARD} className="dropdown-item">
							{localizedText.Portal}
						</a>
						<a href='#' className="dropdown-item" onClick={UserInfo.logUserOut}>
							{localizedText.Logout}
						</a>
					</div>
				</div>
			</div>
		)
	}
}